import { useStore } from 'vuex'
import { computed, ref, onBeforeMount} from 'vue'

import nonEmptyStringValidator from "foundation/js/inputValidators/nonEmptyStringValidator";
import FormInputDropdown from "../FormInputDropdown/FormInputDropdown";

export default {
    name: "MoveFileOverlay",
    components: {
        FormInputDropdown
    },
    setup(){
        const store = useStore()

        const overlayMode = computed(()=> store.state.frivillige.active_overlay_mode)

        onBeforeMount(() => {
            store.dispatch('frivillige/getFolderDropdownOptions')
        })

        const activeFileName = computed(()=> store.state.frivillige.active_file_name)
        const activeFolderName = computed(()=> store.state.frivillige.active_folder_name)
        const activeName = computed(()=>  overlayMode === 'Dokument' ? activeFileName.value : activeFolderName.value)

        const folderDropdown = ref()
        const folderDropdownOptions = computed(()=> store.state.frivillige.folder_dropdown_options)

        const isSubmitting = computed(()=> store.state.frivillige.is_submitting)

        let displayError = ref(false)

        const isFormValid = () => {
            return nonEmptyStringValidator(folderDropdown.value)
        };

        const submitMoveFile = () => {
            const isValid = isFormValid();
            displayError.value = !isValid;

            if (isValid) {
                store.dispatch("frivillige/submitMoveFileOrFolder", {
                    mappeKode: folderDropdown.value
                })
                .then(() => {
                    store.dispatch('main/closePageOverlay')
                    store.dispatch('search/refreshSearches')
                });
            }
        };
        const determineLabelCollection = function() {
            if(overlayMode.value === "Dokument") {
                return "MoveFileOverlay"
            } else if (overlayMode.value === "Mappe"){
                return "MoveFolderOverlay"
            } 
        }

        const getLabel = (labelKey, replacements) => {
            let label = store.getters['labels/getLabel']({ labelCollection: determineLabelCollection(), labelKey: labelKey })
            if (replacements) {
                replacements.forEach((replacement, index) => {
                    label = label.replace(`{${index}}`, replacement)
                })
            }
            return label
        }

        return {
            getLabel,
            submitMoveFile,
            nonEmptyStringValidator,
            activeName,
            folderDropdown,
            folderDropdownOptions,
            isSubmitting
        }
    }
}